"use strict";

const SoaCollection = require('bunsen/collections/SoaCollection');
const AuthorizedRole = require('bunsen/models/identity/AuthorizedRole');
const User = require('bunsen/models/identity/User');
let AuthorizedRoles;

/**
 * An authorized roles collection has 1 method to tell you if your user meets the rquirement from all of the authorized
 * role models conteined therein.
 * @type {Function}
 */
AuthorizedRoles = SoaCollection.extend({

    model: AuthorizedRole,

    /**
     * Returns true if any of the authorized roles matching this user type are not for the user.
     * IE. Tests whether the user is authorized to do {whatever} according to this list of authorized roles.
     * Logic to differentiate user roles from seller roles contained in AuthorizedRole model.
     * @param userOrSeller
     * @returns {boolean}
     */
    isUserPermitted (userOrSeller) {
        return this.any((role) => {
            return role.isPermitted(userOrSeller);
        });
    }

});

module.exports = AuthorizedRoles;



// WEBPACK FOOTER //
// ./~/bunsen/collections/identity/AuthorizedRoles.es.js